<template>
  <v-container fluid pa-0>
    <template v-if="panels">
      <v-expansion-panels>
        <v-expansion-panel v-for="groupKey of groupsKeys" :key="groupKey">
          <v-expansion-panel-header
            ><h5 class="title">
              <slot name="label" :group="groups[groupKey]">{{
                groups[groupKey].label
              }}</slot>
            </h5>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <slot name="table" :items="groups[groupKey].items">
              <p>Your custom data table for group.</p>
            </slot>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </template>
    <div v-else class="py-2" v-for="groupKey of groupsKeys" :key="groupKey">
      <h5 class="title">
        <slot name="label" :group="groups[groupKey]">{{
          groups[groupKey].label
        }}</slot>
      </h5>
      <slot name="table" :items="groups[groupKey].items">
        <p>Your custom data table for group.</p>
      </slot>
    </div>
    <v-row v-if="debug">
      <v-col>
        <pre>{{ groups }}</pre>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "list-grouped",
  props: {
    group: {
      type: Object,
      required: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
    panels: {
      type: Boolean,
      default: () => false,
    },
    reverse: {
      type: Boolean,
      default: () => false,
    },
  },

  data() {
    return {
      debug: false,
    };
  },

  computed: {
    groupsKeys() {
      return this.group.reverse
        ? Object.keys(this.groups).reverse()
        : Object.keys(this.groups);
    },
    groups() {
      return this.groupBy(this.group);
    },
  },
  methods: {
    groupBy(group) {
      return this.items.reverse().reduce((groups, item) => {
        const key = group.getKey(item);
        if (!groups[key]) {
          groups[key] = { label: group.getLabel(item), items: [] };
        }
        groups[key].items.push(item);
        return groups;
      }, {});
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/ListGrouped.vue